
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPlainButton, { OzPlainButtonSizePreset } from '@@/library/v4/components/OzPlainButton.vue'
import { useVirtualKeyboardHeight } from '@@/vuecomposables/virtual_keyboard_height'
import type { HeaderActionButton } from '@@/vuexstore/modules/global_input_dialog'
import { Component, namespace, Vue, Watch } from 'bits/vue'
import OzInputDialogBox from 'library/v4/components/OzInputDialogBox.vue'
import OzOverlay from 'library/v4/components/OzOverlay.vue'

const inputDialogStore = namespace('inputDialog')

@Component({
  components: {
    OzOverlay,
    OzInputDialogBox,
    OzPlainButton,
    OzIcon,
  },
  setup() {
    const { virtualKeyboardHeight } = useVirtualKeyboardHeight()
    return { virtualKeyboardHeight }
  },
})
export default class GlobalInputDialog extends Vue {
  $refs!: {
    dialogBox: OzInputDialogBox
  }

  OzPlainButtonSizePreset = OzPlainButtonSizePreset

  virtualKeyboardHeight!: number

  // This component comes as a pair with vuexstore/modules/global_input_dialog.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @inputDialogStore.State isOpen!: boolean
  @inputDialogStore.State iconSrc!: string | null
  @inputDialogStore.State iconAlt!: string | null
  @inputDialogStore.State headerTopEndContent?: HeaderActionButton
  @inputDialogStore.State title!: string
  @inputDialogStore.State subtitle!: string
  @inputDialogStore.State inputPlaceholder!: string
  @inputDialogStore.State inputValue!: string
  @inputDialogStore.State inputType!: string
  @inputDialogStore.State inputMaxLength!: number | null
  @inputDialogStore.State inputAriaLabel!: string
  @inputDialogStore.State submitButtonText!: string
  @inputDialogStore.State cancelButtonText!: string
  @inputDialogStore.State shouldFadeIn!: boolean
  @inputDialogStore.State submitButtonDisabled!: boolean
  @inputDialogStore.State isValid!: boolean
  @inputDialogStore.State validationMessage!: string

  @inputDialogStore.Action updateInputValue!: (value: string) => void
  @inputDialogStore.Action cancel!: () => void
  @inputDialogStore.Action submit!: () => void

  @Watch('isOpen', { immediate: true })
  respondToDialogOpened(newIsOpen: boolean): void {
    if (newIsOpen) this.$nextTick(() => this.$refs?.dialogBox?.focus())
  }

  executeHeaderTopEndContentActions(): void {
    if (this.headerTopEndContent != null && Array.isArray(this.headerTopEndContent.actions)) {
      const { actions } = this.headerTopEndContent
      actions.forEach((action) => {
        if (typeof action === 'function') action()
      })
    }
  }
}
